export default __webpack_public_path__ + "static/media/card-03.8b07852e.svg";